'use client';

import * as React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

const BASE =
  'w-full bg-surface-3 border border-border-subtle rounded-sm px-3 py-2 pr-9 text-text-primary text-sm placeholder:text-text-tertiary focus:border-accent focus:outline-none transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed appearance-none';

export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...rest }, ref) => {
    return (
      <div className="relative">
        <select ref={ref} className={cn(BASE, className)} {...rest}>
          {children}
        </select>
        <ChevronDown
          className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-secondary pointer-events-none"
          strokeWidth={1.75}
          aria-hidden="true"
        />
      </div>
    );
  }
);
Select.displayName = 'DsSelect';
